export default "__VITE_ASSET__DtyUXUVj__"